import {inject, Injectable} from "@angular/core";
import {ApiService} from "../../../core/api/api.service";
import {catchError, Observable, of} from "rxjs";
import {PostcodeResponseDto} from "../../../core/dto/postcode-response-dto";

@Injectable({
  providedIn: 'root'
})
export class PostcodeService {

  private api = inject(ApiService);

  getPostcode(postcode: string): Observable<PostcodeResponseDto[]> {
    return this.api.getPostcode(postcode).pipe(catchError(() => of([])));
  }
}
